export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://localhost:7072';
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
